export default __webpack_public_path__ + "static/media/team.4f6f1339.svg";